import { Link } from 'react-router'
import clsx from 'clsx'
import type { ButtonHTMLAttributes, ReactNode } from 'react'

type ButtonVariant = 'primary' | 'secondary' | 'inverse'

type ButtonProps = {
  children: ReactNode
  className?: string
  external?: boolean
  href?: string
  to?: string
  variant?: ButtonVariant
} & ButtonHTMLAttributes<HTMLButtonElement>

export const Button = ({
  children,
  className,
  external,
  href,
  to,
  type = 'button',
  variant = 'primary',
  ...props
}: ButtonProps) => {
  const classes = clsx('omni-button', `omni-button--${variant}`, className)

  if (href) {
    return (
      <a
        className={classes}
        href={href}
        rel={external ? 'noopener noreferrer' : undefined}
        target={external ? '_blank' : undefined}
      >
        {children}
      </a>
    )
  }

  if (to) {
    return (
      <Link className={classes} to={to}>
        {children}
      </Link>
    )
  }

  return (
    <button className={classes} type={type} {...props}>
      {children}
    </button>
  )
}
